import { Link } from 'react-router-dom';

const cities = [
  { name: 'Las Vegas', desc: 'Full glass services across the Las Vegas metro area', icon: 'ri-building-4-line' },
  { name: 'Henderson', desc: 'Custom glass installations for Henderson homes & businesses', icon: 'ri-home-4-line' },
  { name: 'North Las Vegas', desc: 'Serving North Las Vegas with premium glass solutions', icon: 'ri-map-pin-2-line' },
  { name: 'Summerlin', desc: 'Luxury glass work for Summerlin\'s finest residences', icon: 'ri-community-line' },
  { name: 'Spring Valley', desc: 'Expert glass services throughout Spring Valley', icon: 'ri-landscape-line' },
  { name: 'Paradise', desc: 'Glass installations for Paradise area homes & hotels', icon: 'ri-hotel-line' },
];

const ServiceAreasPreview = () => {
  return (
    <section className="py-20 md:py-28 bg-[#0A0A0A] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-6">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-gray-500 mb-3 block">Where We Work</span>
            <h2 className="text-4xl md:text-5xl font-light text-white leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Serving the Greater<br />
              <span className="font-semibold">Las Vegas Valley</span>
            </h2>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
            We provide premium glass and mirror services across all major cities and communities in the Las Vegas metropolitan area.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {cities.map((city) => (
            <Link
              key={city.name}
              to="/service-areas"
              className="group flex items-center gap-5 p-6 rounded-2xl border border-gray-800 hover:border-gray-600 hover:bg-gray-900 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gray-800 group-hover:bg-gray-700 transition-colors duration-300 flex-shrink-0">
                <i className={`${city.icon} text-white text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-white font-semibold text-base">{city.name}</h3>
                <p className="text-gray-500 text-xs mt-1 leading-relaxed">{city.desc}</p>
              </div>
              <i className="ri-arrow-right-line text-gray-600 group-hover:text-white group-hover:translate-x-1 transition-all duration-300 flex-shrink-0"></i>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/service-areas"
            className="inline-flex items-center gap-3 border border-gray-700 text-white text-sm font-medium px-8 py-4 rounded-full hover:border-white hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            View All Service Areas
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasPreview;
